import {
	games,
	GetCurrentGamePrefix,
} from "common/constants/Games";
import { Routes, Tabs } from "common/constants/Routes";
import { changeUrl } from "common/history";
import { useLocation } from "react-router-dom";

export const getCurrentTabFromRoute = (loc) => {
	let pathname = loc.pathname.split("?")[0];
	for (const game of games) {
		if (pathname.startsWith(`/${game.prefix}`)) {
			pathname = pathname.substring(game.prefix.length + 1);
			break;
		}
	}

	switch (pathname) {
		case Routes.COMMUNITY:
			return Tabs.COMMUNITY;
		case Routes.LEAGUES:
			return Tabs.LEAGUES;
		case Routes.TROPHYROOM:
			return Tabs.TROPHYROOM;
		case Routes.RLAWARDS:
			return Tabs.RLAWARDS;
		default:
			return Tabs.PICKEMS;
	}
};

export const getTabUrl = (value) => {
	const route = GetCurrentGamePrefix();
	switch (value) {
		case Tabs.LEAGUES:
			return route + Routes.LEAGUES;
		case Tabs.TROPHYROOM:
			return route + Routes.TROPHYROOM;
		case Tabs.COMMUNITY:
			return route + Routes.COMMUNITY;
		case Tabs.RLAWARDS:
			return route + Routes.RLAWARDS;
		case Tabs.PICKEMS:
		default:
			return route;
	}
};

export default function useTabSelect() {
	const location = useLocation();
	const currentTab = getCurrentTabFromRoute(location);
	const updateTab = (value) => changeUrl(getTabUrl(value));
	return [currentTab, updateTab];
}
